export const BEST_OF_AWARDS_WINNERS_MAP: Record<
  string,
  { default: string; additional?: string } | undefined
> = {
  // Blue Cash Everyday
  '5ed2eb69-5e8c-4014-b8b7-23c4d600591c': {
    default: 'Best 0% APR credit card for purchases',
    additional: 'Best credit card for online shopping',
  },
  // Blue Cash Preferred
  '2681330d-450d-4f71-af38-3cb16f592c02': {
    default: 'Best credit card for groceries',
    additional: 'Best credit card for streaming',
  },
  // Chase Sapphire Preferred
  '7dce19da-5d96-4502-9fd2-70ff9655f13a': {
    default: 'Best all-purpose travel rewards credit card',
  },
  // Capital One Venture X
  '39cdfd80-3372-11ec-ba1e-0bd72314c41b': {
    default: 'Best premium travel credit card',
  },
  // Wells Fargo Autograph
  '157b4328-dd47-11ec-9440-d76f3e69ff2f': {
    default: 'Best travel card with no annual fee',
  },
  // Marriott Bonvoy Boundless
  '9c8b7b2c-2c23-46ba-aa5f-0808c13f9da1': {
    default: 'Best hotel credit card',
  },
  // United Explorer
  'ec9ccd68-24a4-4604-8e49-a4175f671b90': {
    default: 'Best airline credit card',
  },
  // Wells Fargo Active Cash
  'b954a46c-caec-11eb-abf1-efb90fc6e740': {
    default: 'Best all-purpose cash back credit card',
  },
  // Citi Custom Cash
  '1c740b9e-c30b-11eb-bc26-6b65e1592891': {
    default: 'Best credit card for gas',
  },
  // Capital One Savor
  'cfeca922-52db-4b18-be5e-8e4fe1448448': {
    default: 'Best credit card for dining',
  },
  // Wells Fargo Attune
  'd6cc160c-916c-11ef-b952-53f803a64bbe': {
    default: 'Best credit card for entertainment',
  },
  // Citi Simplicity
  '697cec98-8d25-45e2-b5d4-24f76d6860c2': {
    default: 'Best balance transfer credit card',
  },
  // Discover it Secured
  'b8802eff-81be-4894-bb9a-89aacde2f55e': {
    default: 'Best credit card for building credit',
  },
  // Discover it Student Chrome
  '5b443d98-8b71-4dfb-b570-f4f23887ee9f': {
    default: 'Best credit card for college students',
  },
};
